angular.module('FYN').service('GeoLocationService', function($http) {
	this.getCity = function() {
		return $http.get('https://freegeoip.net/json/');
	}
	this.getCountry = function() {}
});